export const formatPrice = (n) => {
  if (n === null || n === undefined || n === "" || isNaN(n)) return "Price on request";
  n = Number(n);
  if (n >= 10000000) {
    const v = n / 10000000;
    return `₹${(v % 1 === 0 ? v.toFixed(0) : v.toFixed(2))} Cr`;
  }
  if (n >= 100000) {
    const v = n / 100000;
    return `₹${(v % 1 === 0 ? v.toFixed(0) : v.toFixed(2))} Lakh`;
  }
  return `₹${n.toLocaleString("en-IN")}`;
};

export const perSqft = (price, area) => {
  if (!price || !area) return null;
  return `₹${Math.round(price / area).toLocaleString("en-IN")}/sq.ft`;
};

export const PROPERTY_TYPES = [
  { value: "flat", label: "Flat" },
  { value: "builder_floor", label: "Builder Floor" },
  { value: "plot", label: "Plot" },
  { value: "house", label: "Independent House" },
  { value: "villa", label: "Villa" },
  { value: "commercial", label: "Commercial" },
];

export const typeLabel = (v) => PROPERTY_TYPES.find((t) => t.value === v)?.label || v;

export const assessmentStyle = (a) => {
  const map = {
    "Excellent Value": "bg-indigo-100 text-indigo-800 border-indigo-200",
    "Good Value": "bg-indigo-50 text-indigo-700 border-indigo-200",
    "Fair Price": "bg-blue-50 text-blue-700 border-blue-200",
    "Above Market": "bg-amber-50 text-amber-700 border-amber-200",
    "Premium Pricing": "bg-orange-50 text-orange-700 border-orange-200",
  };
  return map[a] || "bg-slate-100 text-slate-700 border-slate-200";
};

export const scoreColor = (s) => {
  if (!s) return "text-slate-400";
  if (s >= 9) return "text-indigo-600";
  if (s >= 8) return "text-indigo-500";
  if (s >= 7) return "text-blue-500";
  return "text-amber-500";
};

export const budgetOptions = [
  { label: "Any Budget", value: "" },
  { label: "Under ₹50 Lakh", value: "0-5000000" },
  { label: "₹50 Lakh - ₹1 Cr", value: "5000000-10000000" },
  { label: "₹1 Cr - ₹2 Cr", value: "10000000-20000000" },
  { label: "₹2 Cr - ₹4 Cr", value: "20000000-40000000" },
  { label: "Above ₹4 Cr", value: "40000000-100000000" },
];
